import { faBell, faCalendarCheck, faCheckCircle, faClock, faClockRotateLeft, faCopy, faEnvelopeOpenText, faExclamationCircle, faFile, faFileInvoice, faFileSignature, faHeadset, faMoneyBillWave, faReply, faStar } from '@fortawesome/free-solid-svg-icons';
import LibraryPage, { LibraryCard, LibraryCards } from 'components/layout/LibraryPage';
import { useHistory } from 'react-router-dom';
import React, { useState } from 'react';

const EmailTemplateLibrary: React.FC = () => {
    const [selected, setSelected] = useState<LibraryCard | null>(null);
    const history = useHistory();

    // Set the email template options
    const emailTemplateOptions: LibraryCards[] = [
        {
            cards: [
                {
                    type: 'blank_template',
                    icon: faFile,
                    title: 'email.email_template.template_type.blank_template.name',
                    description: 'email.email_template.template_type.blank_template.description'
                }
            ]
        },
        {
            groupHeader: 'email.email_template.connected_feature.proposals',
            requiredFeature: 'proposals',
            cards: [
                {
                    type: 'proposal_send',
                    icon: faFileSignature,
                    title: 'email.email_template.template_type.proposal_send.name',
                    description: 'email.email_template.template_type.proposal_send.description',
                    requiredFeature: 'extended_emails'
                },
                {
                    type: 'proposal_follow_up',
                    icon: faClockRotateLeft,
                    title: 'email.email_template.template_type.proposal_follow_up.name',
                    description: 'email.email_template.template_type.proposal_follow_up.description',
                    requiredFeature: 'extended_emails'
                },
            ]
        },
        {
            groupHeader: 'email.email_template.connected_feature.appointments',
            requiredFeature: 'appointments',
            cards: [
                {
                    type: 'appointment_confirmation_request',
                    icon: faEnvelopeOpenText,
                    title: 'email.email_template.template_type.appointment_confirmation_request.name',
                    description: 'email.email_template.template_type.appointment_confirmation_request.description',
                    requiredFeature: 'extended_emails'
                },
                {
                    type: 'appointment_reminder',
                    icon: faBell,
                    title: 'email.email_template.template_type.appointment_reminder.name',
                    description: 'email.email_template.template_type.appointment_reminder.description',
                    requiredFeature: 'extended_emails'
                },
                {
                    type: 'appointment_confirmation',
                    icon: faCalendarCheck,
                    title: 'email.email_template.template_type.appointment_confirmation.name',
                    description: 'email.email_template.template_type.appointment_confirmation.description',
                    requiredFeature: 'extended_emails'
                },
            ]
        },
        {
            groupHeader: 'email.email_template.connected_feature.jobs',
            requiredFeature: 'jobs',
            cards: [
                {
                    type: 'job_workorder_copy',
                    icon: faCopy,
                    title: 'email.email_template.template_type.job_workorder_copy.name',
                    description: 'email.email_template.template_type.job_workorder_copy.description',
                    requiredFeature: 'extended_emails'
                },
                {
                    type: 'job_finished',
                    icon: faCheckCircle,
                    title: 'email.email_template.template_type.job_finished.name',
                    description: 'email.email_template.template_type.job_finished.description',
                    requiredFeature: 'extended_emails'
                },
                {
                    type: 'customer_rating_request',
                    icon: faStar,
                    title: 'email.email_template.template_type.customer_rating_request.name',
                    description: 'email.email_template.template_type.customer_rating_request.description',
                    requiredFeature: 'extended_emails'
                },
                
            ]
        },
        {
            groupHeader: 'email.email_template.connected_feature.invoices',
            requiredFeature: 'invoices',
            cards: [
                {
                    type: 'invoice_send',
                    icon: faFileInvoice,
                    title: 'email.email_template.template_type.invoice_send.name',
                    description: 'email.email_template.template_type.invoice_send.description',
                    requiredFeature: 'extended_emails'
                },
                {
                    type: 'invoice_reminder',
                    icon: faClock,
                    title: 'email.email_template.template_type.invoice_reminder.name',
                    description: 'email.email_template.template_type.invoice_reminder.description',
                    requiredFeature: 'extended_emails'
                },
                {
                    type: 'invoice_second_reminder',
                    icon: faExclamationCircle,
                    title: 'email.email_template.template_type.invoice_second_reminder.name',
                    description: 'email.email_template.template_type.invoice_second_reminder.description',
                    requiredFeature: 'extended_emails'
                },
                {
                    type: 'invoice_paid_notification',
                    icon: faMoneyBillWave,
                    title: 'email.email_template.template_type.invoice_paid_notification.name',
                    description: 'email.email_template.template_type.invoice_paid_notification.description',
                    requiredFeature: 'extended_emails'
                },  
            ]
        },
        {
            groupHeader: 'email.email_template.connected_feature.tickets',
            requiredFeature: 'tickets',
            cards: [
                {
                    type: 'ticket_acknowledgement',
                    icon: faHeadset,
                    title: 'email.email_template.template_type.ticket_acknowledgement.name',
                    description: 'email.email_template.template_type.ticket_acknowledgement.description',
                },
                {
                    type: 'ticket_reply',
                    icon: faReply,
                    title: 'email.email_template.template_type.ticket_reply.name',
                    description: 'email.email_template.template_type.ticket_reply.description',
                },
            ]
        }
    ];

    // Open the email template page
    const openEmailTemplateForm = (card: LibraryCard) => {
        history.push(`/settings/features/email/template/new/${card.type}`)
    };

    return (
        <LibraryPage
            headerTitle='email.email_template.email_template_example_title'
            backButtonUrl='/settings/features/email/email-templates'
            libraryCards={emailTemplateOptions}
            selected={selected}
            setSelected={setSelected}
            onSubmit={openEmailTemplateForm}
        />
    )
};

export default EmailTemplateLibrary;